import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import AdminHeader from '../components/AdminHeader';
import './AdminStatistics.css';
import './AdminStatistics_Mobile.css';

function AdminStatisticsPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showOrderStatusModal, setShowOrderStatusModal] = useState(false);
  const [showRevenueModal, setShowRevenueModal] = useState(false);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API}/api/admin/statistics`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch statistics');
      }

      const data = await response.json();
      setStats(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ background: '#f8f8f8', minHeight: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>
        {/* Green Header Bar */}
        <div style={{ width: '100%', background: '#175c36', minHeight: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'sticky', top: 0, zIndex: 1001, boxShadow: '0 2px 8px rgba(23, 92, 54, 0.2)' }} />
        
        {/* Navbar */}
        <div style={{ width: '100%', background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(10px)', boxShadow: '0 2px 16px rgba(0,0,0,0.06)', position: 'sticky', top: 32, zIndex: 1000 }}>
          <div style={{ width: '100%', maxWidth: '1800px', margin: '0 auto', background: 'transparent' }}>
            <AdminHeader />
          </div>
        </div>
        
        <div style={{ width: '100%', maxWidth: '1800px', margin: '40px auto', padding: '0 2vw', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1, rotate: 360 }}
            transition={{ duration: 0.6, rotate: { duration: 1, repeat: Infinity, ease: 'linear' } }}
            style={{ fontSize: '4rem' }}
          >
            🌱
          </motion.div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ background: '#f8f8f8', minHeight: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>
        {/* Green Header Bar */}
        <div style={{ width: '100%', background: '#175c36', minHeight: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'sticky', top: 0, zIndex: 1001, boxShadow: '0 2px 8px rgba(23, 92, 54, 0.2)' }} />
        
        {/* Navbar */}
        <div style={{ width: '100%', background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(10px)', boxShadow: '0 2px 16px rgba(0,0,0,0.06)', position: 'sticky', top: 32, zIndex: 1000 }}>
          <div style={{ width: '100%', maxWidth: '1800px', margin: '0 auto', background: 'transparent' }}>
            <AdminHeader />
          </div>
        </div>
        
        <div style={{ width: '100%', maxWidth: '1800px', margin: '40px auto', padding: '0 2vw', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            style={{ 
              background: '#fff', 
              padding: '40px 32px', 
              borderRadius: '16px', 
              boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
              textAlign: 'center',
              maxWidth: '450px',
              width: '100%',
              margin: '0 20px',
              border: '2px solid #fee'
            }}
          >
            <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⚠️</div>
            <div style={{ fontSize: '1.3rem', color: '#d32f2f', fontWeight: 700, marginBottom: '12px' }}>Error Loading Statistics</div>
            <div style={{ fontSize: '1rem', color: '#666', marginBottom: '28px', lineHeight: '1.6' }}>{error}</div>
            <motion.button 
              onClick={fetchStatistics}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{
                background: 'linear-gradient(135deg, #7a9c3a 0%, #5e7c2a 100%)',
                color: '#fff',
                border: 'none',
                padding: '14px 32px',
                borderRadius: '12px',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(122, 156, 58, 0.25)',
                minHeight: '48px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
              Retry Loading
            </motion.button>
          </motion.div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-statistics-page">
      {/* Green Header Bar */}
      <div style={{ width: '100%', background: '#175c36', minHeight: 32, height: 32, position: 'sticky', top: 0, zIndex: 1001, boxShadow: '0 2px 8px rgba(23, 92, 54, 0.2)' }}></div>
      
      {/* Navbar */}
      <div style={{ width: '100%', background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(10px)', boxShadow: '0 2px 16px rgba(0,0,0,0.06)', position: 'sticky', top: 32, zIndex: 1000 }}>
        <div style={{ width: '100%', maxWidth: '1800px', margin: '0 auto', background: 'transparent' }}>
          <AdminHeader />
        </div>
      </div>

      <div className="statistics-container">
        {/* Page Title */}
        <div className="page-header fade-in">
          <h1 style={{ letterSpacing: '0.5px' }}>Statistics & Analytics</h1>
          <p style={{ opacity: 0.9 }}>Comprehensive overview of your business performance</p>
        </div>

        {/* Key Metrics Cards */}
        <div className="metrics-grid">
          {/* Row 1: Financial Metrics */}
          
          {/* Revenue Card */}
          <motion.div 
            className="metric-card revenue-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.05 }}
            onClick={() => setShowRevenueModal(true)}
            style={{ cursor: 'pointer' }}
          >
            <div className="metric-icon">₱</div>
            <div className="metric-content">
              <h3>Total Revenue</h3>
              <div className="metric-value">₱{stats.revenue.total.toLocaleString('en-PH', { minimumFractionDigits: 2 })}</div>
              <div className="metric-subtext">
                This Month: ₱{stats.revenue.monthly.toLocaleString('en-PH', { minimumFractionDigits: 2 })}
                {stats.revenue.growth !== 0 && (
                  <span className={stats.revenue.growth > 0 ? 'growth-positive' : 'growth-negative'}>
                    {stats.revenue.growth > 0 ? '↑' : '↓'} {Math.abs(stats.revenue.growth)}%
                  </span>
                )}
              </div>
            </div>
          </motion.div>

          {/* Average Order Value Card */}
          <motion.div 
            className="metric-card avg-order-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            onClick={() => setShowRevenueModal(true)}
            style={{ cursor: 'pointer' }}
          >
            <div className="metric-icon">💰</div>
            <div className="metric-content">
              <h3>Avg Order Value</h3>
              <div className="metric-value">₱{stats.revenue.average.toLocaleString('en-PH', { minimumFractionDigits: 2 })}</div>
              <div className="metric-subtext">Per completed order</div>
            </div>
          </motion.div>

          {/* Inventory Value Card */}
          <motion.div 
            className="metric-card inventory-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.15 }}
            onClick={() => navigate('/admin/products')}
            style={{ cursor: 'pointer' }}
          >
            <div className="metric-icon">📊</div>
            <div className="metric-content">
              <h3>Inventory Value</h3>
              <div className="metric-value">₱{stats.products.inventoryValue.toLocaleString('en-PH', { minimumFractionDigits: 2 })}</div>
              <div className="metric-subtext">Total stock value</div>
            </div>
          </motion.div>

          {/* Row 2: Operations Metrics */}

          {/* Orders Card */}
          <motion.div 
            className="metric-card orders-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            onClick={() => navigate('/admin/orders')}
            style={{ cursor: 'pointer' }}
          >
            <div className="metric-icon">📦</div>
            <div className="metric-content">
              <h3>Total Orders</h3>
              <div className="metric-value">{stats.orders.total.toLocaleString()}</div>
              <div className="metric-subtext">
                This Month: {stats.orders.monthly} orders
              </div>
            </div>
          </motion.div>

          {/* Products Card */}
          <motion.div 
            className="metric-card products-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.25 }}
            onClick={() => navigate('/admin/products')}
            style={{ cursor: 'pointer' }}
          >
            <div className="metric-icon">🌿</div>
            <div className="metric-content">
              <h3>Products</h3>
              <div className="metric-value">{stats.products.total}</div>
              <div className="metric-subtext">
                In Stock: {stats.products.inStock} | Low Stock: {stats.products.lowStock}
              </div>
            </div>
          </motion.div>

          {/* Customers Card */}
          <motion.div 
            className="metric-card customers-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
            onClick={() => navigate('/admin/customers')}
            style={{ cursor: 'pointer' }}
          >
            <div className="metric-icon">👥</div>
            <div className="metric-content">
              <h3>Customers</h3>
              <div className="metric-value">{stats.customers.total}</div>
              <div className="metric-subtext">
                New This Month: {stats.customers.newThisMonth} | Admins: {stats.customers.admins}
              </div>
            </div>
          </motion.div>
        </div>

        {/* Charts Section */}
        <div 
          className="charts-section"
        >
          {/* Revenue by Month Chart */}
          <div 
            className="chart-card"
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
              <h3 style={{ margin: 0 }}>Revenue Trend (Last 6 Months)</h3>
              <motion.button
                className="view-all-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowRevenueModal(true)}
                style={{
                  background: 'linear-gradient(135deg, #7a9c3a 0%, #5e7c2a 100%)',
                  color: '#fff',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 8px rgba(122, 156, 58, 0.25)'
                }}
              >
                View
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
              </motion.button>
            </div>
            <div className="bar-chart">
              {stats.revenue.byMonth.map((month, index) => {
                const maxRevenue = Math.max(...stats.revenue.byMonth.map(m => m.revenue));
                
                // Better scaling: show clear visual difference
                let height;
                if (maxRevenue === 0) {
                  height = 5; // All zeros
                } else if (month.revenue === 0) {
                  height = 5; // This month has no revenue
                } else {
                  // Scale from 15% to 100% for better visual distinction
                  height = 15 + ((month.revenue / maxRevenue) * 85);
                }
                
                return (
                  <motion.div 
                    key={index} 
                    className="bar-container"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: 0.4 + (index * 0.05) }}
                  >
                    <div className="bar-label">₱{(month.revenue / 1000).toFixed(0)}k</div>
                    <div className="bar-wrapper">
                      <motion.div 
                        className="bar" 
                        style={{ 
                          height: `${height}%`,
                          opacity: month.revenue === 0 ? 0.3 : 1
                        }}
                        title={`₱${month.revenue.toLocaleString()}`}
                        initial={{ scaleY: 0 }}
                        animate={{ scaleY: 1 }}
                        transition={{ duration: 0.5, delay: 0.5 + (index * 0.05), ease: 'easeOut' }}
                      ></motion.div>
                    </div>
                    <div className="bar-month">{month.month}</div>
                  </motion.div>
                );
              })}
            </div>
          </div>

          {/* Orders by Status Chart - Minimal View */}
          <div 
            className="chart-card orders-status-card"
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ margin: 0 }}>Orders by Status</h3>
              <motion.button
                className="view-all-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowOrderStatusModal(true)}
                style={{
                  background: 'linear-gradient(135deg, #7a9c3a 0%, #5e7c2a 100%)',
                  color: '#fff',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 8px rgba(122, 156, 58, 0.25)'
                }}
              >
                View
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
              </motion.button>
            </div>
            <div className="status-breakdown">
              {stats.orders.byStatus
                .filter(s => ['Pending', 'Awaiting Payment', 'Preparing', 'Completed'].includes(s.status))
                .map((status, index) => {
                  const percentage = ((status.count / stats.orders.total) * 100).toFixed(1);
                  const colors = {
                    'Pending': '#ff9800',
                    'Awaiting Payment': '#ffa726',
                    'Preparing': '#2196f3',
                    'Completed': '#388e3c'
                  };
                  
                  return (
                    <motion.div 
                      key={index} 
                      className="status-row"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.3, delay: 0.4 + (index * 0.05) }}
                    >
                      <div className="status-info">
                        <span 
                          className="status-dot" 
                          style={{ background: colors[status.status] }}
                        ></span>
                        <span className="status-name">{status.status}</span>
                      </div>
                      <div className="status-bar-container">
                        <motion.div 
                          className="status-bar" 
                          style={{ 
                            width: `${percentage}%`,
                            background: colors[status.status]
                          }}
                          initial={{ scaleX: 0 }}
                          animate={{ scaleX: 1 }}
                          transition={{ duration: 0.5, delay: 0.5 + (index * 0.05), ease: 'easeOut' }}
                        ></motion.div>
                      </div>
                      <span className="status-count">{status.count} ({percentage}%)</span>
                    </motion.div>
                  );
                })}
            </div>
          </div>
        </div>

        {/* Order Status Modal */}
        {showOrderStatusModal && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowOrderStatusModal(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.6)',
              backdropFilter: 'blur(4px)',
              zIndex: 2000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px',
              overflowY: 'auto'
            }}
          >
            <motion.div
              className="modal-content"
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                background: '#fff',
                borderRadius: '16px',
                padding: '32px',
                maxWidth: '800px',
                width: '100%',
                maxHeight: '90vh',
                overflowY: 'auto',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                position: 'relative'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', paddingBottom: '20px', borderBottom: '2px solid #e8e8e8' }}>
                <h2 style={{ margin: 0, color: '#2c3e50', fontSize: '1.6rem', fontWeight: 700 }}>Order Status Overview</h2>
                <motion.button
                  onClick={() => setShowOrderStatusModal(false)}
                  whileHover={{ scale: 1.1, rotate: 90 }}
                  whileTap={{ scale: 0.9 }}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '1.8rem',
                    cursor: 'pointer',
                    color: '#999',
                    lineHeight: 1,
                    padding: '0',
                    width: '36px',
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#f0f0f0'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
                >
                  ×
                </motion.button>
              </div>

              <div style={{ marginBottom: '28px', padding: '20px 24px', background: 'linear-gradient(135deg, #f0f7ff 0%, #e8f4f8 100%)', borderRadius: '12px', border: '1px solid #d0e7ff' }}>
                <div style={{ fontSize: '0.95rem', color: '#2c5282', fontWeight: 700, marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '1.2rem' }}>📊</span>
                  Total Orders: {stats.orders.total}
                </div>
                <div style={{ fontSize: '0.85rem', color: '#64748b', marginLeft: '28px' }}>
                  Comprehensive breakdown of all order statuses
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {stats.orders.byStatus.map((status, index) => {
                  const percentage = ((status.count / stats.orders.total) * 100).toFixed(1);
                  const colors = {
                    'Pending': '#ff9800',
                    'Awaiting Payment': '#ffa726',
                    'Payment Confirmed': '#66bb6a',
                    'Preparing': '#2196f3',
                    'Shipped': '#9c27b0',
                    'Delivered': '#4caf50',
                    'Completed': '#388e3c',
                    'Cancelled': '#f44336',
                    'Ready for Pickup': '#42a5f5'
                  };
                  
                  return (
                    <motion.div 
                      key={index} 
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.3, delay: index * 0.04 }}
                      style={{ 
                        padding: '16px 20px',
                        background: '#fff',
                        borderRadius: '12px',
                        border: '1px solid #e8e8e8',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <span 
                            style={{ 
                              background: colors[status.status],
                              width: '10px',
                              height: '10px',
                              borderRadius: '50%',
                              display: 'inline-block',
                              boxShadow: `0 0 0 3px ${colors[status.status]}20`
                            }}
                          ></span>
                          <span style={{ fontSize: '1rem', fontWeight: 600, color: '#2c3e50' }}>{status.status}</span>
                        </div>
                        <span style={{ fontSize: '1rem', fontWeight: 700, color: colors[status.status] }}>
                          {status.count} <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#64748b' }}>({percentage}%)</span>
                        </span>
                      </div>
                      <div style={{
                        width: '100%',
                        height: '10px',
                        background: '#f1f5f9',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        position: 'relative'
                      }}>
                        <motion.div 
                          style={{ 
                            width: `${percentage}%`,
                            height: '100%',
                            background: `linear-gradient(90deg, ${colors[status.status]} 0%, ${colors[status.status]}dd 100%)`,
                            borderRadius: '10px',
                            minWidth: '4px',
                            boxShadow: `0 0 8px ${colors[status.status]}40`
                          }}
                          initial={{ scaleX: 0, originX: 0 }}
                          animate={{ scaleX: 1 }}
                          transition={{ duration: 0.6, delay: 0.1 + (index * 0.04), ease: 'easeOut' }}
                        ></motion.div>
                      </div>
                    </motion.div>
                  );
                })}
              </div>

              <motion.button
                onClick={() => setShowOrderStatusModal(false)}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                style={{
                  marginTop: '32px',
                  width: '100%',
                  background: 'linear-gradient(135deg, #7a9c3a 0%, #5e7c2a 100%)',
                  color: '#fff',
                  border: 'none',
                  padding: '16px',
                  borderRadius: '12px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(122, 156, 58, 0.25)'
                }}
              >
                Close
              </motion.button>
            </motion.div>
          </motion.div>
        )}

        {/* Revenue Trend Modal */}
        {showRevenueModal && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowRevenueModal(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.6)',
              backdropFilter: 'blur(4px)',
              zIndex: 2000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px',
              overflowY: 'auto'
            }}
          >
            <motion.div
              className="modal-content"
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                background: '#fff',
                borderRadius: '16px',
                padding: '32px',
                maxWidth: '900px',
                width: '100%',
                maxHeight: '90vh',
                overflowY: 'auto',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                position: 'relative'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <h2 style={{ margin: 0, color: '#2c3e50', fontSize: '1.8rem' }}>Revenue Trend Analysis</h2>
                <motion.button
                  onClick={() => setShowRevenueModal(false)}
                  whileHover={{ scale: 1.1, rotate: 90 }}
                  whileTap={{ scale: 0.9 }}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '2rem',
                    cursor: 'pointer',
                    color: '#999',
                    lineHeight: 1,
                    padding: '0',
                    width: '36px',
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#f0f0f0'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
                >
                  ×
                </motion.button>
              </div>

              <div style={{ marginBottom: '24px', padding: '20px', background: '#f0f7ff', borderRadius: '12px', border: '1px solid #d0e7ff' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                  <div>
                    <div style={{ fontSize: '0.85rem', color: '#2c5282', fontWeight: 600, marginBottom: '4px' }}>Total Revenue</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#7a9c3a' }}>
                      ₱{stats.revenue.total.toLocaleString('en-PH', { minimumFractionDigits: 2 })}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.85rem', color: '#2c5282', fontWeight: 600, marginBottom: '4px' }}>This Month</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#2196f3' }}>
                      ₱{stats.revenue.monthly.toLocaleString('en-PH', { minimumFractionDigits: 2 })}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.85rem', color: '#2c5282', fontWeight: 600, marginBottom: '4px' }}>Average Order</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#9c27b0' }}>
                      ₱{stats.revenue.average.toLocaleString('en-PH', { minimumFractionDigits: 2 })}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.85rem', color: '#2c5282', fontWeight: 600, marginBottom: '4px' }}>Growth Rate</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 700, color: stats.revenue.growth >= 0 ? '#4caf50' : '#f44336' }}>
                      {stats.revenue.growth >= 0 ? '↑' : '↓'} {Math.abs(stats.revenue.growth)}%
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#2c3e50', marginBottom: '20px' }}>Monthly Breakdown</h3>
                <div style={{ 
                  display: 'flex', 
                  gap: '20px', 
                  justifyContent: 'space-between', 
                  alignItems: 'flex-end', 
                  height: '280px',
                  padding: '24px 16px 0',
                  background: 'linear-gradient(to bottom, #fafafa 0%, #ffffff 100%)',
                  borderRadius: '12px',
                  border: '1px solid #e8e8e8',
                  position: 'relative'
                }}>
                  {stats.revenue.byMonth.map((month, index) => {
                    const maxRevenue = Math.max(...stats.revenue.byMonth.map(m => m.revenue));
                    let heightPx;
                    if (maxRevenue === 0) {
                      heightPx = 40;
                    } else if (month.revenue === 0) {
                      heightPx = 40;
                    } else {
                      // Scale from 40px to 200px
                      heightPx = 40 + ((month.revenue / maxRevenue) * 160);
                    }
                    
                    return (
                      <div 
                        key={index}
                        style={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          minWidth: 0,
                          position: 'relative',
                          height: '100%',
                          justifyContent: 'flex-end'
                        }}
                        onMouseEnter={(e) => {
                          const label = e.currentTarget.querySelector('.revenue-label');
                          const bar = e.currentTarget.querySelector('.revenue-bar');
                          if (label) label.style.opacity = '1';
                          if (bar) {
                            bar.style.transform = 'scale(1.05)';
                            bar.style.filter = 'brightness(1.1)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          const label = e.currentTarget.querySelector('.revenue-label');
                          const bar = e.currentTarget.querySelector('.revenue-bar');
                          if (label) label.style.opacity = '0';
                          if (bar) {
                            bar.style.transform = 'scale(1)';
                            bar.style.filter = 'brightness(1)';
                          }
                        }}
                      >
                        <div
                          className="revenue-label"
                          style={{ 
                            fontSize: '0.9rem', 
                            fontWeight: 700, 
                            color: '#fff',
                            background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
                            padding: '6px 12px',
                            borderRadius: '6px',
                            textAlign: 'center',
                            position: 'absolute',
                            bottom: `${heightPx + 16}px`,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            whiteSpace: 'nowrap',
                            opacity: 0,
                            transition: 'opacity 0.3s ease',
                            pointerEvents: 'none',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                            zIndex: 10,
                            border: '1px solid rgba(255, 255, 255, 0.1)'
                          }}
                        >
                          ₱{(month.revenue / 1000).toFixed(1)}k
                        </div>
                        <div
                          className="revenue-bar"
                          style={{
                            width: '100%',
                            maxWidth: '60px',
                            height: `${heightPx}px`,
                            background: month.revenue === 0 
                              ? 'linear-gradient(180deg, #e0e0e0 0%, #d0d0d0 100%)'
                              : 'linear-gradient(180deg, #8cb947 0%, #6a9532 50%, #5e7c2a 100%)',
                            borderRadius: '8px 8px 0 0',
                            boxShadow: month.revenue === 0 
                              ? '0 2px 8px rgba(0, 0, 0, 0.05)' 
                              : '0 4px 16px rgba(122, 156, 58, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            marginBottom: '12px',
                            position: 'relative'
                          }}
                          title={`₱${month.revenue.toLocaleString('en-PH', { minimumFractionDigits: 2 })}`}
                        ></div>
                        <div style={{ 
                          fontSize: '0.85rem', 
                          fontWeight: 600, 
                          color: '#475569',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          width: '100%',
                          padding: '4px 0'
                        }}>
                          {month.month}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#2c3e50', marginBottom: '16px' }}>Detailed Statistics</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
                  {stats.revenue.byMonth.map((month, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3, delay: index * 0.03 }}
                      style={{
                        padding: '16px',
                        background: '#fff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                      }}
                    >
                      <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#2c3e50', marginBottom: '8px' }}>
                        {month.month}
                      </div>
                      <div style={{ fontSize: '1.3rem', fontWeight: 700, color: '#7a9c3a', marginBottom: '4px' }}>
                        ₱{month.revenue.toLocaleString('en-PH', { minimumFractionDigits: 2 })}
                      </div>
                      <div style={{ fontSize: '0.8rem', color: '#666' }}>
                        {((month.revenue / stats.revenue.total) * 100).toFixed(1)}% of total revenue
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>

              <motion.button
                onClick={() => setShowRevenueModal(false)}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                style={{
                  marginTop: '24px',
                  width: '100%',
                  background: 'linear-gradient(135deg, #7a9c3a 0%, #5e7c2a 100%)',
                  color: '#fff',
                  border: 'none',
                  padding: '14px',
                  borderRadius: '12px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(122, 156, 58, 0.25)'
                }}
              >
                Close
              </motion.button>
            </motion.div>
          </motion.div>
        )}

        {/* Top Products Section */}
        {stats.topProducts.length > 0 && (
          <motion.div 
            className="top-products-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.45 }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ margin: 0 }}>Top Selling Products</h3>
              <motion.button
                className="view-all-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate('/admin/products')}
              >
                View All →
              </motion.button>
            </div>
            <div className="top-products-grid">
              {stats.topProducts.slice(0, 5).map((product, index) => {
                console.log('Product data:', product);
                const isOutOfStock = product.stock === 0;
                const isLowStock = product.stock > 0 && product.stock <= 10;
                const revenue = product.quantitySold * product.price;
                
                return (
                  <motion.div 
                    key={index} 
                    className="top-product-card"
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3, delay: 0.5 + (index * 0.05) }}
                    whileHover={{ y: -4, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}
                    onClick={() => {
                      console.log('Navigating with product ID:', product._id);
                      navigate('/admin/products', { state: { openProductId: product._id } });
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="product-rank">#{index + 1}</div>
                    
                    {/* Product Image */}
                    <div className="product-image-container">
                      {product.image ? (
                        <img 
                          src={product.image} 
                          alt={product.name}
                          style={{
                            width: '100%',
                            height: '120px',
                            objectFit: 'cover',
                            borderRadius: '8px'
                          }}
                        />
                      ) : (
                        <div style={{
                          width: '100%',
                          height: '120px',
                          background: 'linear-gradient(135deg, #7a9c3a 0%, #5e7c2a 100%)',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '3rem'
                        }}>
                          🌿
                        </div>
                      )}
                      {isOutOfStock && (
                        <div style={{
                          position: 'absolute',
                          top: '8px',
                          right: '8px',
                          background: '#f44336',
                          color: '#fff',
                          padding: '4px 8px',
                          borderRadius: '6px',
                          fontSize: '0.7rem',
                          fontWeight: 600
                        }}>
                          Out of Stock
                        </div>
                      )}
                      {isLowStock && (
                        <div style={{
                          position: 'absolute',
                          top: '8px',
                          right: '8px',
                          background: '#ff9800',
                          color: '#fff',
                          padding: '4px 8px',
                          borderRadius: '6px',
                          fontSize: '0.7rem',
                          fontWeight: 600
                        }}>
                          Low Stock
                        </div>
                      )}
                    </div>
                    
                    <div className="product-details">
                      <h4 style={{ marginBottom: '8px' }}>{product.name}</h4>
                      <div className="product-stats">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '1.2rem' }}>📦</span>
                          <span>Sold: <strong>{product.quantitySold}</strong></span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '1.2rem' }}>💰</span>
                          <span>Price: <strong>₱{product.price.toLocaleString()}</strong></span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '1.2rem' }}>📊</span>
                          <span>Stock: <strong style={{ color: isOutOfStock ? '#f44336' : isLowStock ? '#ff9800' : '#388e3c' }}>{product.stock}</strong></span>
                        </div>
                        <div style={{ 
                          marginTop: '8px', 
                          paddingTop: '8px', 
                          borderTop: '1px solid #e0e0e0',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}>
                          <span style={{ fontSize: '1.2rem' }}>💵</span>
                          <span style={{ fontSize: '0.85rem', color: '#666' }}>Revenue: <strong style={{ color: '#7a9c3a', fontSize: '0.95rem' }}>₱{revenue.toLocaleString()}</strong></span>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>
        )}

        {/* Additional Stats */}
        <motion.div 
          className="additional-stats"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.5 }}
        >
          <motion.div 
            className="stat-box"
            whileHover={{ y: -4, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}
            onClick={() => navigate('/admin/products')}
            style={{ cursor: 'pointer' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '1.5rem' }}>📦</span>
                Product Status
              </h4>
              <span style={{ fontSize: '0.85rem', color: '#7a9c3a', fontWeight: 600 }}>View →</span>
            </div>
            
            {/* Pie Chart for Product Status */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', margin: '20px 0' }}>
              <svg width="180" height="180" viewBox="0 0 180 180" style={{ transform: 'rotate(-90deg)' }}>
                {(() => {
                  const total = stats.products.total;
                  if (total === 0) return null;
                  
                  const inStockPercent = (stats.products.inStock / total) * 100;
                  const outOfStockPercent = (stats.products.outOfStock / total) * 100;
                  const lowStockPercent = (stats.products.lowStock / total) * 100;
                  
                  const radius = 70;
                  const circumference = 2 * Math.PI * radius;
                  
                  // Calculate cumulative percentages for positioning
                  const inStockDash = (inStockPercent / 100) * circumference;
                  const outOfStockDash = (outOfStockPercent / 100) * circumference;
                  const lowStockDash = (lowStockPercent / 100) * circumference;
                  
                  return (
                    <>
                      {/* In Stock - Green */}
                      <circle
                        cx="90"
                        cy="90"
                        r={radius}
                        fill="none"
                        stroke="#4caf50"
                        strokeWidth="35"
                        strokeDasharray={`${inStockDash} ${circumference}`}
                        strokeDashoffset="0"
                      />
                      {/* Out of Stock - Red */}
                      <circle
                        cx="90"
                        cy="90"
                        r={radius}
                        fill="none"
                        stroke="#f44336"
                        strokeWidth="35"
                        strokeDasharray={`${outOfStockDash} ${circumference}`}
                        strokeDashoffset={-inStockDash}
                      />
                      {/* Low Stock - Orange */}
                      <circle
                        cx="90"
                        cy="90"
                        r={radius}
                        fill="none"
                        stroke="#ff9800"
                        strokeWidth="35"
                        strokeDasharray={`${lowStockDash} ${circumference}`}
                        strokeDashoffset={-(inStockDash + outOfStockDash)}
                      />
                      {/* Center circle for donut effect */}
                      <circle cx="90" cy="90" r="45" fill="white" />
                      <text x="90" y="85" textAnchor="middle" fill="#2c3e50" fontSize="24" fontWeight="bold" transform="rotate(90 90 90)">{total}</text>
                      <text x="90" y="105" textAnchor="middle" fill="#666" fontSize="12" transform="rotate(90 90 90)">Products</text>
                    </>
                  );
                })()}
              </svg>
              
              {/* Legend */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f8f9fa', borderRadius: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#4caf50' }}></div>
                    <span style={{ fontSize: '0.9rem', color: '#444' }}>In Stock</span>
                  </div>
                  <strong style={{ fontSize: '0.95rem' }}>{stats.products.inStock}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f8f9fa', borderRadius: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#f44336' }}></div>
                    <span style={{ fontSize: '0.9rem', color: '#444' }}>Out of Stock</span>
                  </div>
                  <strong style={{ fontSize: '0.95rem', color: '#f44336' }}>{stats.products.outOfStock}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f8f9fa', borderRadius: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#ff9800' }}></div>
                    <span style={{ fontSize: '0.9rem', color: '#444' }}>Low Stock</span>
                  </div>
                  <strong style={{ fontSize: '0.95rem', color: '#ff9800' }}>{stats.products.lowStock}</strong>
                </div>
              </div>
            </div>
            
            <div style={{ borderTop: '2px solid #e0e0e0', paddingTop: '12px', marginTop: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.95rem', color: '#666' }}>
                <span style={{ fontSize: '1.2rem' }}>💎</span>
                Total Stock Value
              </span>
              <strong style={{ color: '#7a9c3a', fontSize: '1.1rem' }}>₱{stats.products.inventoryValue.toLocaleString('en-PH', { minimumFractionDigits: 2 })}</strong>
            </div>
          </motion.div>

          <motion.div 
            className="stat-box"
            whileHover={{ y: -4, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}
            onClick={() => navigate('/admin/customers')}
            style={{ cursor: 'pointer' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '1.5rem' }}>👥</span>
                Customer Engagement
              </h4>
              <span style={{ fontSize: '0.85rem', color: '#7a9c3a', fontWeight: 600 }}>View →</span>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', margin: '20px 0' }}>
              <svg width="180" height="180" viewBox="0 0 180 180" style={{ transform: 'rotate(-90deg)' }}>
                {(() => {
                  const withOrders = stats.customers.withOrders;
                  const withoutOrders = stats.customers.total - stats.customers.withOrders;
                  const total = stats.customers.total;
                  if (total === 0) return null;
                  
                  const withOrdersPercent = (withOrders / total) * 100;
                  const withoutOrdersPercent = (withoutOrders / total) * 100;
                  
                  const radius = 70;
                  const circumference = 2 * Math.PI * radius;
                  const withOrdersSegment = (withOrdersPercent / 100) * circumference;
                  const withoutOrdersSegment = (withoutOrdersPercent / 100) * circumference;

                  return (
                    <>
                      <circle
                        cx="90"
                        cy="90"
                        r={radius}
                        fill="none"
                        stroke="#4caf50"
                        strokeWidth="35"
                        strokeDasharray={`${withOrdersSegment} ${circumference}`}
                        strokeDashoffset="0"
                      />
                      <circle
                        cx="90"
                        cy="90"
                        r={radius}
                        fill="none"
                        stroke="#2196f3"
                        strokeWidth="35"
                        strokeDasharray={`${withoutOrdersSegment} ${circumference}`}
                        strokeDashoffset={-withOrdersSegment}
                      />
                      <circle cx="90" cy="90" r="45" fill="white" />
                      <text x="90" y="85" textAnchor="middle" fill="#2c3e50" fontSize="24" fontWeight="bold" transform="rotate(90 90 90)">{total}</text>
                      <text x="90" y="105" textAnchor="middle" fill="#666" fontSize="12" transform="rotate(90 90 90)">Customers</text>
                    </>
                  );
                })()}
              </svg>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f8f9fa', borderRadius: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#4caf50' }}></div>
                    <span style={{ fontSize: '0.9rem', color: '#444' }}>With Orders</span>
                  </div>
                  <strong style={{ fontSize: '0.95rem', color: '#4caf50' }}>{stats.customers.withOrders}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f8f9fa', borderRadius: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#2196f3' }}></div>
                    <span style={{ fontSize: '0.9rem', color: '#444' }}>Without Orders</span>
                  </div>
                  <strong style={{ fontSize: '0.95rem' }}>{stats.customers.total - stats.customers.withOrders}</strong>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="stat-box"
            whileHover={{ y: -4, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}
            onClick={() => navigate('/admin/promos')}
            style={{ cursor: 'pointer' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '1.5rem' }}>🎉</span>
                Promo Codes
              </h4>
              <span style={{ fontSize: '0.85rem', color: '#7a9c3a', fontWeight: 600 }}>View →</span>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', margin: '20px 0' }}>
              <svg width="180" height="180" viewBox="0 0 180 180" style={{ transform: 'rotate(-90deg)' }}>
                {(() => {
                  const active = stats.promotions.active;
                  const inactive = stats.promotions.total - stats.promotions.active;
                  const total = stats.promotions.total;
                  if (total === 0) return null;
                  
                  const activePercent = (active / total) * 100;
                  const inactivePercent = (inactive / total) * 100;
                  
                  const radius = 70;
                  const circumference = 2 * Math.PI * radius;
                  const activeSegment = (activePercent / 100) * circumference;
                  const inactiveSegment = (inactivePercent / 100) * circumference;

                  return (
                    <>
                      <circle
                        cx="90"
                        cy="90"
                        r={radius}
                        fill="none"
                        stroke="#4caf50"
                        strokeWidth="35"
                        strokeDasharray={`${activeSegment} ${circumference}`}
                        strokeDashoffset="0"
                      />
                      <circle
                        cx="90"
                        cy="90"
                        r={radius}
                        fill="none"
                        stroke="#9e9e9e"
                        strokeWidth="35"
                        strokeDasharray={`${inactiveSegment} ${circumference}`}
                        strokeDashoffset={-activeSegment}
                      />
                      <circle cx="90" cy="90" r="45" fill="white" />
                      <text x="90" y="85" textAnchor="middle" fill="#2c3e50" fontSize="24" fontWeight="bold" transform="rotate(90 90 90)">{total}</text>
                      <text x="90" y="105" textAnchor="middle" fill="#666" fontSize="12" transform="rotate(90 90 90)">Promo Codes</text>
                    </>
                  );
                })()}
              </svg>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f8f9fa', borderRadius: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#4caf50' }}></div>
                    <span style={{ fontSize: '0.9rem', color: '#444' }}>Active</span>
                  </div>
                  <strong style={{ fontSize: '0.95rem', color: '#4caf50' }}>{stats.promotions.active}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f8f9fa', borderRadius: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#9e9e9e' }}></div>
                    <span style={{ fontSize: '0.9rem', color: '#444' }}>Inactive</span>
                  </div>
                  <strong style={{ fontSize: '0.95rem' }}>{stats.promotions.total - stats.promotions.active}</strong>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Recent Activity */}
        {stats.recentActivity.length > 0 && (
          <motion.div 
            className="recent-activity-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.55 }}
          >
            <h3>Recent Activity</h3>
            <div className="activity-list">
              {stats.recentActivity.map((activity, index) => (
                <motion.div 
                  key={index} 
                  className="activity-item"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: 0.6 + (index * 0.05) }}
                  whileHover={{ scale: 1.01 }}
                  whileTap={{ scale: 0.99 }}
                >
                  <div className="activity-icon">📋</div>
                  <div className="activity-details">
                    <strong>{activity.customerName}</strong>
                    <span> placed order #{activity.orderId.toString().slice(-6)}</span>
                    <div className="activity-meta">
                      <span className="activity-amount">₱{activity.amount.toLocaleString()}</span>
                      <span className={`activity-status status-${activity.status.toLowerCase()}`}>
                        {activity.status}
                      </span>
                      <span className="activity-date">
                        {new Date(activity.date).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}

        {/* Quick Actions */}
        {/* Removed quick action buttons */}
      </div>

      {/* Green Footer Bar */}
      <motion.div 
        className="green-footer-bar"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.7 }}
      >
        <span>© {new Date().getFullYear()} Chiqui's Garden</span>
      </motion.div>
    </div>
  );
}

export default AdminStatisticsPage;
